import { render } from "./orglisting.vue?vue&type=template&id=944faf74&scoped=true"
import script from "./orglisting.js?vue&type=script&lang=js"
export * from "./orglisting.js?vue&type=script&lang=js"

import "./orglisting.vue?vue&type=style&index=0&id=944faf74&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-944faf74"]])

export default __exports__